/*
 * testimonialsReducer.js
 * trt_cms2
 *
 * Created by Hisyam on 09/03/2020, 3:29 PM.
 * Copyright (c) 2020 Terato Tech. All rights reserved.
 */

import {
  ADD_TESTIMONIAL, ADD_TESTIMONIAL_FULFILLED, DELETE_TESTIMONIAL, DELETE_TESTIMONIAL_FULFILLED,
  FETCH_TESTIMONIAL, FETCH_TESTIMONIAL_FULFILLED,
  FETCH_TESTIMONIALS,
  FETCH_TESTIMONIALS_FULFILLED, RESET_REDIRECT_TESTIMONIAL,
  UPDATE_TESTIMONIAL, UPDATE_TESTIMONIAL_FULFILLED
} from "../types";

const initialState = {
  isLoading: false,
  redirect: false,
  errors: {},
  limit: 10,
  offset: 0,
  count: 0,
  testimonials: [],
  testimonial: {},
};

export const testimonialsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TESTIMONIALS:
      return {
        ...state,
        isLoading: true,
        limit: action.payload.limit,
        offset: action.payload.offset
      };

    case FETCH_TESTIMONIALS_FULFILLED:
      return {
        ...state,
        isLoading: false,
        count: action.payload.count,
        testimonials: action.payload.results,
      };

    case FETCH_TESTIMONIAL:
    case ADD_TESTIMONIAL:
    case UPDATE_TESTIMONIAL:
    case DELETE_TESTIMONIAL:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_TESTIMONIAL_FULFILLED:
      return {
        ...state,
        isLoading: false,
        testimonial: {
          ...state.testimonial,
          [action.payload.id]: action.payload
        }
      };

    case ADD_TESTIMONIAL_FULFILLED:
    case UPDATE_TESTIMONIAL_FULFILLED:
      return {
        ...state,
        isLoading: false,
        redirect: true,
        testimonial: {
          ...state.testimonial,
          [action.payload.id]: action.payload
        }
      };

    case DELETE_TESTIMONIAL_FULFILLED:
      return {
        ...state,
        isLoading: false,
        redirect: true,
        testimonials: state.testimonials.filter(testimonial => testimonial.id !== action.payload),
        testimonial: Object.keys(state.testimonial)
          .filter(key => key !== String(action.payload))
          .reduce((obj, key) => obj[key] = state.testimonial[key], {})
      };

    case RESET_REDIRECT_TESTIMONIAL:
      return {
        ...state,
        redirect: false,
      };

    default:
      return state;
  }
};